import { FC } from 'react';
import { Modal, ModalOverlay } from '@chakra-ui/react';
import { useRegistrationStore } from '../../hooks';
import { REGISTRATION_STEP } from '../../../../constants/registrationStep';
import { MenuCategoryRegistrationInputModalView } from './MenuCategoryRegistrationInputModalView';
import { MenuCategoryRegistrationConfirmModalView } from './MenuCategoryRegistrationConfirmModalView';
import { MenuCategoryRegistrationResultModalView } from './MenuCategoryRegistrationResultModalView';

type Props = ReturnType<typeof useRegistrationStore>;

export const MenuCategoryRegistrationModalView: FC<Props> = ({
  isOpenModal,
  onCloseModal,
  onCloseModalWhenCompleted,
  currentModalStep,
  form,
  values,
  onConfirm,
  onGoBack,
  onSubmit,
}) => (
  <Modal
    isOpen={isOpenModal}
    onClose={onCloseModal}
    size="4xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    {currentModalStep === REGISTRATION_STEP.INPUT && (
      <MenuCategoryRegistrationInputModalView
        {...form}
        handleConfirm={onConfirm}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.CONFIRMATION && (
      <MenuCategoryRegistrationConfirmModalView
        values={values}
        handleBack={onGoBack}
        handleSubmit={onSubmit}
      />
    )}
    {currentModalStep === REGISTRATION_STEP.RESULT && (
      <MenuCategoryRegistrationResultModalView
        values={values}
        handleClose={onCloseModalWhenCompleted}
      />
    )}
  </Modal>
);
